import {
  Box,
  Button,
  Divider,
  Grid,
  Stack,
  Typography,
  Checkbox,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CartItem } from "./CartItem";
import {
  assignCartNetAmount,
  assignCartDiscountAmount,
  assignCartMRP,
  assignCartTaxAmount,
  setCouponDiscount,
  clearCoupon,
} from "../../../redux/reducers/Cart";
import Calculation from "../../../utility/Calculations";
import ApplyCouponModal from "../Coupons/ApplyCouponModal";

const CartDetails = ({ handleNext }) => {
  //#region code
  const { currency } = useSelector((state) => state.GlobalVariables);
  const [openCouponModal, setOpenCouponModal] = React.useState(false);

  const dispatch = useDispatch();
  const {
    cartValue,
    cartMRP,
    cartDiscountAmount,
    cartTaxAmount,
    cartNetAmount,
    selectedCoupons,
    couponDiscount,
  } = useSelector((state) => state.cart);

  console.log("selectedCoupons=", selectedCoupons);
 


  const totalAmount = () => {
    let totalMRP = 0,
      totalDiscount = 0,
      totalTaxAmount = 0,
      netAmount = 0;
    cartValue.map((item) => {
      totalMRP += item.qty * item.rate;
      totalDiscount +=
        item.qty * Calculation.discountAmount(item.rate, item.discount);
      totalTaxAmount +=
        item.qty *
        Calculation.taxAmount(item.rate, item.discount, item.Taxrate);
      netAmount +=
        item.qty *
        Calculation.netAmount(item.rate, item.discount, item.Taxrate);
    });
     // Final Net Amount minus couponDiscount
  const finalNetAmount = netAmount - (couponDiscount || 0);
    dispatch(assignCartMRP(totalMRP));
    dispatch(assignCartDiscountAmount(totalDiscount));
    dispatch(assignCartTaxAmount(totalTaxAmount));
    dispatch(assignCartNetAmount(finalNetAmount));
  };
  useEffect(() => {
    totalAmount();
  }, [cartValue]);

  useEffect(() => {

    totalAmount();
  }, [selectedCoupons,couponDiscount]);

  const calculateCouponDiscount = () => {
    if (!selectedCoupons?.length) {
      dispatch(setCouponDiscount(0));
      return;
    }

    const coupon = selectedCoupons[0];
    if (!coupon || !cartValue?.length) {
      dispatch(clearCoupon());
      return;
    }

    let applicableItems = [];

    if (coupon.apply_on === "all") {
      applicableItems = cartValue;
    } else if (
      coupon.apply_on === "specific_items" &&
      Array.isArray(coupon.items)
    ) {
      const productIds = coupon.items.map((item) => item.product_id);
      applicableItems = cartValue.filter((item) =>
        productIds.includes(item.id)
      );
    }

    if (!applicableItems?.length) {
      dispatch(clearCoupon());
      return;
    }

    let discount = 0;

    if (coupon.discount_type === "percentage") {
      const totalApplicableAmount = applicableItems.reduce(
        (sum, item) => sum + item.qty * item.rate,
        0
      );

      discount =
        (totalApplicableAmount * parseFloat(coupon.discount_value)) / 100;

      if (coupon.max_discount && discount > parseFloat(coupon.max_discount)) {
        discount = parseFloat(coupon.max_discount);
      }
    } else if (coupon.discount_type === "fixed") {
      discount = parseFloat(coupon.discount_value);
    }

    dispatch(setCouponDiscount(discount));
  };

  useEffect(() => {
    calculateCouponDiscount(); // auto re-calculate
  }, [cartValue, selectedCoupons]);


  // console.log("selectedCoupons", selectedCoupons);
  //#endregion

  return (
    <>
      <ApplyCouponModal
        open={openCouponModal}
        handleClose={() => setOpenCouponModal(false)}
      />

      <Grid container spacing={2} px={3}>
        {/* First Grid (Cart Items) */}
        <Grid item xs={12} md={6}>
          {cartValue.map((item) => {
            return <CartItem key={item.id} data={item} />;
          })}
        </Grid>

        {/* Second Grid (Price Details) */}
        <Grid
          item
          xs={12}
          md={6}
          mt={2}
          border={"solid 1px #e0e0e0"}
          borderRadius={"8px"}
          p={3}
          sx={{
            background: "#fff",
            height: "auto",
            alignSelf: "flex-start",
          }}
        >
          {/* Coupons Section */}
          <Typography variant="subtitle2" color="#666" gutterBottom>
            COUPONS
          </Typography>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={1}
          >
            <Typography variant="body2">Apply Coupons</Typography>
            <Button
              variant="outlined"
              size="small"
              sx={{
                fontWeight: "bold",
                borderColor: "#f50057",
                color: "#f50057",
              }}
              onClick={() => setOpenCouponModal(true)}
            >
             {
              selectedCoupons?.length > 0 ? "EDIT" : "APPLY"
             }
            </Button>
          </Box>

          <Divider sx={{ my: 2 }} />

          <Divider sx={{ my: 2 }} />

          {/* Price Details */}
          <Typography variant="subtitle2" color="#666" gutterBottom>
            PRICE DETAILS ({cartValue?.length} Item
            {cartValue?.length > 1 ? "s" : ""})
          </Typography>

          <Box display="flex" justifyContent="space-between" my={1}>
            <Typography> Total MRP </Typography>
            <Typography> ₹{cartMRP} </Typography>
          </Box>

          <Box display="flex" justifyContent="space-between" my={1}>
            <Typography>
              Discount on MRP{" "}
              {/* <Typography component="span" variant="caption" color="#f50057">
                Know More
              </Typography> */}
            </Typography>
            <Typography color="success.main">-₹{cartDiscountAmount}</Typography>
          </Box>
          <Box display="flex" justifyContent="space-between" my={1}>
            <Typography>
              GST on MRP{" "}
              {/* <Typography component="span" variant="caption" color="#f50057">
                Know More
              </Typography> */}
            </Typography>
            <Typography color="success.main">+₹{cartTaxAmount}</Typography>
          </Box>

          <Box display="flex" justifyContent="space-between" my={1}>
            <Typography>Coupon Discount</Typography>
            <Typography color="success.main">
              -₹{(couponDiscount ?? 0).toFixed(2)}
            </Typography>
          </Box>

          {/* <Box display="flex" justifyContent="space-between" my={1}>
            <Typography>
              Platform Fee{" "}
              <Typography component="span" variant="caption" color="#f50057">
                Know More
              </Typography>
            </Typography>
            <Typography>₹20</Typography>
          </Box> */}

          <Divider sx={{ my: 2 }} />

          <Box display="flex" justifyContent="space-between" my={1}>
            <Typography variant="h6">Total Amount</Typography>
            <Typography variant="h6" fontWeight="bold">
              ₹{cartNetAmount}
            </Typography>
          </Box>

          <Box mt={2}>
            <Button
              fullWidth
              variant="contained"
              color="error"
              size="large"
              sx={{ borderRadius: "4px" }}
              onClick={handleNext}
            >
              PLACE ORDER
            </Button>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};
export default CartDetails;
